var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTransferWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-transfer-white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19.972,
    viewBox: "0 0 18 19.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14476",
    "data-name": "Caminho 14476",
    d: "M237.048,503.68H224.017l1.759-1.759a1.126,1.126,0,1,0-1.592-1.592l-3.68,3.68a1.126,1.126,0,0,0,0,1.592l3.68,3.68a1.126,1.126,0,1,0,1.592-1.592l-1.759-1.759h13.031a1.126,1.126,0,1,0,0-2.251Z",
    transform: "translate(-220.174 -489.639)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14477",
    "data-name": "Caminho 14477",
    d: "M237.85,242.445l-3.68-3.68a1.126,1.126,0,1,0-1.592,1.592l1.759,1.759H221.306a1.126,1.126,0,0,0,0,2.251h13.031l-1.759,1.759a1.126,1.126,0,1,0,1.592,1.592l3.68-3.68A1.126,1.126,0,0,0,237.85,242.445Z",
    transform: "translate(-220.179 -238.435)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTransferWhite);
export default __webpack_public_path__ + "static/media/ico-transfer-white.647320170092330fd35f56fba38a5b1d.svg";
export { ForwardRef as ReactComponent };